import { useState, useEffect } from 'react';
import { Checkbox } from '@nextui-org/react';
import Input from '../../../ui/input';
import DateInput from '../../../ui/date-input';
import { useFormContext, useFieldArray } from "react-hook-form";
import { reasons } from '../constants';
import Text from '../../../ui/text';
import Select from '../../../ui/select';

function ElectionReasons() {
  const { 
    register,
    watch,
    control,
    formState: { errors },
  } = useFormContext();
  const [checked, setChecked] = useState('');
  const { fields, replace, update } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "electionReasons", // unique name for your Field Array
  });
  useEffect(() => {
    if (fields.length === 0) {
      replace(reasons);
    }
  }, []);
  const watchElectionReasons = watch("electionReasons");

  useEffect(() => {
    if (fields?.length > 0) {
      fields.forEach((item, index) => {
        update(index, {...item, checked: item.value === checked })
      });
    }
  }, [checked]);

  return (
    <section className="w-full">
      <h2 className="text-xl font-semibold opacity-[var(--sds-size-stroke-border)] text-sky-950">
        <Text>Election Periods</Text>
      </h2>
      <p className="mt-5 text-base leading-1">
        <Text>Typically, you may enroll in a Medicare Advantage plan only during the Annual Enrollment Period from October 15 through December 7 of each year. There are exceptions that may allow you to enroll in a Medicare Advantage Plan outside of this period.</Text>
      </p>
      <p className="mt-3 text-base leading-1">
        <Text>Please read the following statements carefully and check the box if the statement applies to you. By checking any of the following boxes, you are certifying that, to the best of your knowledge, you are eligible for an election period. If we later determine that this information is incorrect, you may be disenrolled.</Text>
      </p>
      <div className='w-full mt-5 flex flex-row justify-start items-center gap-3'>
        <Text className='font-bold text-sm'>Proposed Effective Date:</Text> 
        <div>
          <DateInput
            name='proposedEffectiveDate'
            control={control}
            size='sm'
            className='inline'
            aria-label={<Text>Proposed Effective Date</Text>}
            label=''
            isInvalid={errors?.proposedEffectiveDate ? true : false}
          />  
        </div> 
      </div>
      <div className='mt-5 w-full flex flex-col gap-3'>
        {fields && fields.map((field, index) => (
          <div key={index} className='w-full flex flex-row gap-2 justify-start'>
            <div>
              <Checkbox
                id={`electionReasons.${index}.checked`}
                aria-label={<Text>Option</Text>}
                label=''
                name={`electionReasons.${index}.checked`}
                onValueChange={() => setChecked(field.value)}
                isSelected={field.checked}
                //{...register(`electionReasons.${index}.checked`)}
              />
            </div>
            <div className='w-full'>
              <label aria-label='option' className='mr-2 inline' htmlFor={`electionReasons.${index}.checked`}>{field.label}</label>
              {field.hasDateInput && (
                <DateInput
                  name={`electionReasons.${index}.date`}
                  control={control}
                  size='sm'
                  className='inline'
                  aria-label={<Text>Option</Text>}
                  label=''
                  isDisabled={!watchElectionReasons[index].checked}
                  isInvalid={errors?.electionReasons?.[index]?.date ? true : false}
                  classNames={watchElectionReasons[index].checked && !errors?.electionReasons?.[index]?.date ? {
                    inputWrapper: ["border border-secondary"]
                  } : {}}
                /> 
              )}
              {field.hasDateInputTo && (
                <>
                  <span> to </span>
                  <DateInput
                    name={`electionReasons.${index}.dateTo`}
                    control={control}
                    size='sm'
                    className='inline'
                    aria-label={<Text>Option</Text>}
                    label=''
                    isDisabled={!watchElectionReasons[index].checked}
                    isInvalid={errors?.electionReasons?.[index]?.dateTo ? true : false}
                    classNames={watchElectionReasons[index].checked && !errors?.electionReasons?.[index]?.dateTo ? {
                      inputWrapper: ["border border-secondary"]
                    } : {}}
                  />
                </>
              )}
              {field.hasTextInput && (
                <div className='w-full'>
                  <Input
                    size='sm'
                    aria-label={<Text>Option</Text>}
                    label=''
                    {...register(`electionReasons.${index}.text`)}  
                    isInvalid={errors?.electionReasons?.[index]?.text ? true : false}
                    isDisabled={!watchElectionReasons[index].checked}
                    classNames={watchElectionReasons[index].checked && !errors?.electionReasons?.[index]?.text ? {
                      inputWrapper: ["border border-secondary"]
                    } : {}}
                  />
                </div>
              )}
              {field.hasSelectInput && (
                <Select
                  size='sm'
                  aria-label={<Text>Option</Text>}
                  label=''
                  {...register(`electionReasons.${index}.text`)}
                  options={field.selectOptions}
                  selectionMode="single"
                  isDisabled={!watchElectionReasons[index].checked}
                  isInvalid={errors?.electionReasons?.[index]?.text ? true : false}
                  className='inline'
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ElectionReasons;